module.exports = __webpack_public_path__ + "7d088296/img/SOURCERY_poweredby_web.9819842b.png";